<template>
  <div>
    <b-row>
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" sm="12">
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">
              {{ $t("emergency.Patient Emergency Details") }}
            </h2>
          </div>
          <div>
            <h5 class="my-2">
              <b> {{ $t("common.patient-name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ PatientEmergencyData[0].patient_card.patient.name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b> {{ $t("emergency.Companinon name") }}:</b>
              <p class="mx-2 d-inline d-inline">
                {{ PatientEmergencyData[0].patient_card.full_companion_name }}
              </p>
            </h5>
            <h5 class="my-2">
              <b>{{ $t("emergency.Companinon Phonenumber") }}:</b>
              <p class="mx-2 d-inline" style="unicode-bidi: isolate" :style="{  direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr' }">
                {{ PatientEmergencyData[0].patient_card.companion_phone }}
              </p>
            </h5>
          </div>

          <div>
            <h5 class="my-2">
              <b>{{ $t("emergency.Card number") }}:</b>
              <p class="mx-2 d-inline">
                {{ PatientEmergencyData[0].patient_card.card_no }}
              </p>
            </h5>
          </div>
        </b-card>
        <b-card>
          <PateintCardTest
            :patientCardId="PatientEmergencyData[0].patient_card.id"
            v-if="$store.state.app.permissions.includes('get-patientCardTest')"
          />
          <PatientEmergency
            :patientCardId="PatientEmergencyData[0].patient_card.id"
            v-if="PatientEmergencyData[0].patient_card.type == 'EMERGENCY'"
          />
          <!-- <PatientDrug
            :patientCardId="PatientEmergencyData[0].patient_card.id"
            v-if="
              PatientEmergencyData[0].patient_card.type == 'IN' ||
              PatientEmergencyData[0].patient_card.type == 'EMERGENCY' ||
              PatientEmergencyData[0].patient_card.type == 'CLINIC' ||
              PatientEmergencyData[0].patient_card.type == 'OUT'
            "
          /> -->
        </b-card>
        <h3 class="my-2 text-center">{{ $t("emergency.Emergency Cards") }}</h3>
        <div v-for="(item, index) in PatientEmergencyData" :key="index">
          <EmergencyCard :index="index" :emegencyItem="item" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";

const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PateintCardTest from "@/views/lab/PatientCardTest.vue";
import PatientEmergency from "@/views/emergency/PatientEmergency.vue"; //
import PatientDrug from "@/views/pharmacy/PatientDrug.vue";
import EmergencyCard from "@/views/emergency/EmergencyCard.vue";

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormInput,
    BFormGroup,
    BCard,
    BCardText,
    BButton,
    PateintCardTest,
    PatientDrug,
    PatientEmergency,
    AutoComplete,
    vSelect,
    ToastificationContent,
    EmergencyCard,
  },
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
      PatientEmergencyData: {},
      patientTest: {},
      patientTestForm: {
        patient_card_id: "",
        tests: [],
        _method: "PUT",
      },

      patientRadiology: {},
      patientRadiologyForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
    };
  },
  mounted() {
    this.getPatientEmergencyInfo();
  },

  methods: {
    async getPatientEmergencyInfo() {
      await this.getPatient(
        `emergency?filter[patient_card_id]=${this.$route.params.id}&include=patientCard`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.PatientEmergencyData = this.all_data.data;
      console.log("PatientEmergencyData", this.PatientEmergencyData);
    },
  },
};
</script>
